import React from "react";
import "../Footer/Footer.css";
import { FaLinkedin } from "react-icons/fa";
import { TbBrandYoutubeFilled } from "react-icons/tb";
import { MdEmail } from "react-icons/md";
import eyeOnTheFutureLogo from "../../assets/logos/logo2.png";

function Footer() {
  return (
    <div id="footer" className="footer-container">
      <div>
        <h2>Wassim Mahmoud</h2>
        <div className="Social-media">
          <a
            target="_blank"
            href="https://www.linkedin.com/in/wassim-mahmoud/"
            rel="noopener noreferrer"
          >
            <FaLinkedin className="icon" />
          </a>
          <a
            target="_blank"
            href="https://www.youtube.com/@wassimmahmoud7062"
            rel="noopener noreferrer"
          >
            <TbBrandYoutubeFilled className="icon" />
          </a>
          <a
            target="_blank"
            href="mailto:wassim.mhd@hotmail.com"
            rel="noopener noreferrer"
          >
            <MdEmail className="icon" />
          </a>
        </div>
      </div>

      <div className="company-information">
        <p>Eye On The Future</p>
        <p>
          &copy;2024 <span>Eye On The Future</span>, All rights reserved.
        </p>
      </div>
      <div className="photo">
        <a
          target="_blank"
          href="https://www.eye-on-the-future.com"
          rel="noopener noreferrer"
        >
          <img src={eyeOnTheFutureLogo} alt="Eye On The Future Logo" />
        </a>
      </div>
    </div>
  );
}

export default Footer;
